import axios from 'axios';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getFrameProducts = async () => {
  const response = await axios.get('/api/frame-products', {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const createFrameProduct = async (payload) => {
  const response = await axios.post('/api/frame-products', payload, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const updateFrameProduct = async (id, payload) => {
  const response = await axios.patch(`/api/frame-products/${id}`, payload, {
    headers: getAuthHeaders()
  });
  return response.data;
};

// Frame photos — one per colour (each colour is its own frame product).
// Upload a picture before the frame exists; returns its public URL.
export const uploadFrameImage = async (file) => {
  const body = new FormData();
  body.append('image', file);
  const response = await axios.post('/api/frame-products/upload-image', body, {
    headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' }
  });
  return response.data.url;
};

// Add or replace the photo of an existing frame; returns the updated product.
export const setFrameProductImage = async (id, file) => {
  const body = new FormData();
  body.append('image', file);
  const response = await axios.post(`/api/frame-products/${id}/image`, body, {
    headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const deleteFrameProduct = async (id) => {
  const response = await axios.delete(`/api/frame-products/${id}`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const getFrameStock = async ({ location, filters }) => {
  const response = await axios.get('/api/frame-stock', {
    headers: getAuthHeaders(),
    params: {
      locationType: location?.type,
      locationId: location?.id,
      ...filters
    }
  });
  return response.data;
};

export const updateFrameStock = async ({ location, updates }) => {
  const response = await axios.patch('/api/frame-stock', {
    locationType: location?.type,
    locationId: location?.id,
    updates
  }, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const getFrameAlerts = async ({ location }) => {
  const response = await axios.get('/api/frame-stock/alerts', {
    headers: getAuthHeaders(),
    params: {
      locationType: location?.type,
      locationId: location?.id
    }
  });
  return response.data;
};

export const returnFrameToCentral = async ({ frameProductId, qty }) => {
  const response = await axios.post('/api/stock-transfers/frames/return-to-central', {
    frameProductId,
    qty
  }, {
    headers: getAuthHeaders()
  });
  return response.data;
};
